import { takeEvery } from 'redux-saga/effects';
import { EMPLOYMENT_LIST_FETCH } from '../constants';
import { employmentListSaga } from './employmentSaga';

export function* rootEmploymentSaga() {
  yield takeEvery(EMPLOYMENT_LIST_FETCH, employmentListSaga);
}
